import React, { useEffect, useState } from "react";
import styles from "./userData.module.css";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddUser } from "../addUser/AddUser";
import { useGetAllUserQuery } from "../../../features/api/user/userApi";
import dateFormatter from "../../../utils/dateFormatter";
import { useIsAdmin } from "../../../customHooks/roleChecker/useIsAdmin";
import { useIsSuperAdmin } from "../../../customHooks/roleChecker/useIsSuperAdmin";

export const UserData = () => {
  const isAdmin = useIsAdmin();
  const isSuperAdmin = useIsSuperAdmin();
  const [key, setKey] = useState("User List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);

  // Fetching data from API
  const { data, isLoading, isError } = useGetAllUserQuery();

  return (
    <div className="container pt-5">
      <Tabs
        id="controlled-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="User List" title="User List">
          <div className={styles.tableContainer}>
            {isLoading ? (
              <p>Loading...</p>
            ) : isError ? (
              <p>Error fetching data</p>
            ) : (
              <>
                <table className={styles.customTable}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>User </th>
                      <th>Role </th>
                      <th>Created At </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((user, idx) => (
                        <tr
                          key={user.id}
                          onClick={() => navigate(`/user-details/${user.id}`)}
                        >
                          <td>{idx + 1}</td>
                          <td className={styles.itemName}>
                            {user.firstName} {user.lastName}
                          </td>
                          <td>{user.role}</td>
                          <td>{dateFormatter(user.createdAt)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className={styles.noData}>
                          No user found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </Tab>

        {(isAdmin || isSuperAdmin) && (
          <Tab eventKey="Add User" title="Add User">
            <AddUser onSuccess={() => setKey("User List")} />
          </Tab>
        )}
      </Tabs>
    </div>
  );
};
